import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { FileUpIcon, PlusIcon } from "lucide-react";

type VehicleMakesToolbarProps = {
  onCreate: () => void;
  canCreate: boolean;
  canImport?: boolean;
};

export function VehicleMakesToolbar({
  onCreate,
  canCreate,
  canImport = false,
}: VehicleMakesToolbarProps) {
  const nav = useNavigate();

  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">ຍີ່ຫໍ້ລົດ</h2>
        <p className="text-muted-foreground text-sm">
          ຈັດການຍີ່ຫໍ້ລົດ — ກົດເຂົ້າແຕ່ລະຍີ່ຫໍ້ເພື່ອຈັດການຮຸ່ນ ແລະ configuration
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        {canImport ? (
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/catalog/vehicles/import" })}
          >
            <FileUpIcon className="size-4" />
            ນຳເຂົ້າ CSV/Excel
          </Button>
        ) : null}
        {canCreate ? (
          <Button onClick={onCreate}>
            <PlusIcon className="size-4" />
            ເພີ່ມຍີ່ຫໍ້
          </Button>
        ) : null}
      </div>
    </div>
  );
}
